export const colors = {
  textMain: "#000E2A",
  textSecondary: "#353A46",
  textPrimary: "#2266EF",
  labelText: "#353A46",
  placeholderText: "rgba(61, 77, 105, 0.7)",
  panelBackground: "#eaf0f5",
  greenBackground: "#5fbb722b",
  blueBackground: "#d2e4ff",
  tableHeaderBackground: "#D4EEFD",

  primary: "#2266EF",
  secondary: "#F3F5F9",
  primaryLight: "#2266EF1A",
  primaryDisabled: "#dce2ef",

  success: "#4AB37B",
  successMedium: "#6ab36e",
  successLight: "#CCEBDA",
  successText: "#087641",

  warning: "#EA9F48",
  warningMedium: "#fad59d",
  warningLight: "#fdf3e4",

  error: "#EF717D",
  errorMedium: "#ffacb4",
  errorLight: "#fff6f7",
  errorDisabled: "#ffc7cc",

  purple: "#6f7aff",
  purpleMedium: "#9a96f9",
  purpleLight: "#d9d7fc",

  blue: "#4d94fb",
  blueMedium: "#98c3ff",
  blueLight: "#d2e4fe",
  blueTag: "#4d94ff40",

  violet: "#6776CB",

  gray: "#7f9dbf", // mark as paid
  grayMedium: "#B0CBD6", // save as draft
  grayLight: "#CDE2EA",
  grayHover: "#8DADBA",

  sand: "#AF9B89",
  sandMedium: "#CCBAA9",
  sandLight: "#F4E3D4",

  // plan gray color
  planGray: "#6686a2",
  playGrayLight: "#eaf2f9",

  blackButton: "#465065",
  focusShadow: "#F5F5F5",

  white: "#fff",
  whiteBg: "#fcfdfe",
  // job status
  unscheduled: "#ea9f48",
  readyToDispatch: "#606CFF",

  green: "#18B54D",
  blueText: "#2266EF",

  greyLodder: "#7B7B7B",

  // Auth & Onboarding colors
  authBackground: "#eef1f7",
  authTextPrimary: "#1e2223",
  authTextSecondary: "#4b4e4f",
  authTextTertiary: "#787a7b",
  authBorderDefault: "#949fb3",
  authBorderError: "#ff5722",
  authErrorBackground: "#ff5722",
  authFooterBackground: "#d5ddeb",
  authQuoteBackground: "#f9fafb",
  authBlue: "#2684ff",
  authBlueLight: "#eff6ff",
  authGradient: "linear-gradient(90deg, #33ccae 0%, #2684ff 100%)",
  authGray: "#6b7280",
  authPurple: "#aa8ef6",

  //dangerColors
  error2: "#FF5722",
  error2Medium: "#ff6b6b",
  error2Light: "#FECDB4",

  // Google Brand Colors
  googleRed: "#eb4335",
  googleYellow: "#fbbc05",
  googleGreen: "#34a853",
  googleBlue: "#4285f4",

  // Modal colors
  overlayBackground: "rgba(1, 65, 78, 0.5)",
  modalBoxShadow: "rgba(0, 0, 0, 0.3)",
  blueShadow: "rgba(38, 132, 255, 0.1)",
};

export const hoverColors = {
  primary: "#1158E5",
  error: "#ed5160",
  warning: "#f09b16",
  purpleMedium: "#8985ea",
  blue: "#3f86f0",
  gray: "#6d8caf",
  grayMedium: "#8ea1b5",
  planGray: "#617f9a",
  blackButton: "#1f2939",
};

export const borderColors = {
  primary: colors.primary,
  secondary: "#c2cce1",
  secondaryLight: "#999FAA",
  blackButton: "#1f2939",
  error: colors.error,
  tableBorder: "#E9F0FE",
};

export const hoverBorderColors = {
  secondaryLight: "#434343b3",
};

export const gradientColors = {
  primary: "linear-gradient(135deg, #33ccae, #9747ff)",
  bar: "linear-gradient(135deg, rgba(220, 195, 254, 0.4), rgba(168, 217, 209, 0.4))",
  popup: "linear-gradient(135deg, #ccfaec, #e5d1ff)",
};